package com.daytimegaming.ourdailyfinances.data.network.service

import com.daytimegaming.ourdailyfinances.data.network.ApiClient
import com.daytimegaming.ourdailyfinances.data.network.dto.UserResponseDto
import com.daytimegaming.ourdailyfinances.data.network.dto.UpdateUserRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.GooglePlaySyncRequest
import com.daytimegaming.ourdailyfinances.data.network.dto.AppleAppStoreSyncRequest
import io.ktor.client.call.body
import io.ktor.client.request.delete
import io.ktor.client.request.get
import io.ktor.client.request.post
import io.ktor.client.request.patch
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType

class UserService(private val apiClient: ApiClient) {
    suspend fun getUserMe(): UserResponseDto =
        apiClient.http.get("${apiClient.baseUrl}/users/me").body()

    suspend fun createUserMe(): UserResponseDto =
        apiClient.http.post("${apiClient.baseUrl}/users/me").body()

    suspend fun updateUserMe(firstName: String?, lastName: String?): UserResponseDto =
        apiClient.http.patch("${apiClient.baseUrl}/users/me") {
            contentType(ContentType.Application.Json)
            setBody(UpdateUserRequest(userFirstName = firstName, userLastName = lastName))
        }.body()

    suspend fun syncGooglePlayPurchase(request: GooglePlaySyncRequest): UserResponseDto =
        apiClient.http.post("${apiClient.baseUrl}/users/me/subscriptions/google-play") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun syncAppleAppStorePurchase(request: AppleAppStoreSyncRequest): UserResponseDto =
        apiClient.http.post("${apiClient.baseUrl}/users/me/subscriptions/apple-storekit") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun cancelSubscription(): UserResponseDto =
        apiClient.http.post("${apiClient.baseUrl}/users/me/subscriptions/cancel").body()

    suspend fun registerDeviceToken(token: String): com.daytimegaming.ourdailyfinances.data.network.dto.MessageResponse =
        apiClient.http.post("${apiClient.baseUrl}/users/me/device-tokens") {
            contentType(ContentType.Application.Json)
            setBody(com.daytimegaming.ourdailyfinances.data.network.dto.DeviceTokenRequest(token))
        }.body()

    suspend fun unregisterDeviceToken(token: String): com.daytimegaming.ourdailyfinances.data.network.dto.MessageResponse =
        apiClient.http.delete("${apiClient.baseUrl}/users/me/device-tokens/$token").body()
}

